import { useParams } from "react-router-dom";
import { PageHeader } from "@/components/page";
import { AddTeamMemberDialog } from "@/components/teams/teamMember/AddTeamMemberDialog";
import { TeamMembersTable } from "@/components/teams/teamMember/TeamMembersTable";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";
import { useGetTeam } from "@/hooks/queryHooks/teamHooks";

export const TeamPage = () => {
  const { tenantId, teamId } = useParams();
  useRoleProtected("admin");

  const { data: tenantData } = useGetTenantByFriendly(tenantId ?? "");
  const { data: teamData } = useGetTeam(tenantData?.id ?? "", teamId ?? "");

  if (!teamData || !tenantData) return null;

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader title={`${tenantData.name}: ${teamData.name}`}>
        {" "}
        {tenantData.id && (
          <AddTeamMemberDialog tenantId={tenantData.id} teamId={teamData.id} />
        )}
      </PageHeader>
      {tenantData?.id && (
        <DataTableWrapper>
          <TeamMembersTable tenantId={tenantData.id} teamId={teamData.id} />
        </DataTableWrapper>
      )}
    </div>
  );
};
